import {Fragment} from "preact";
import s from "./checkboxInput.module.css";
import {useAppContext} from "../../../../../../contexts";

const CheckboxInput = (props) => {
    // Destructured props
    const {
        option,
        formValues,
        handleChange
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Checks if the current checkbox is checked
    const isChecked = formValues.selectedOptions.includes(option.id);

    return (
        <Fragment>
            <fieldset>
                <input
                    type="checkbox"
                    name={"option"}
                    id={`option-input-${option.id}`}
                    className={"hidden"}
                    value={option.id}
                    checked={isChecked}
                    onInput={() => handleChange({
                        target: "OPTIONS",
                        optionId: option.id,
                    })}
                />
                <label
                    htmlFor={`option-input-${option.id}`}
                    className={
                        `${highContrast ? s.dmLabel : s.label} ${highContrast ? s.dmLabel : ""} ${isChecked ? (
                            highContrast ? s.dmIsChecked : s.isChecked
                        ) : ""}`
                    }
                >
                    {option.label}
                </label>
            </fieldset>
        </Fragment>
    )
}

export default CheckboxInput
